import React from 'react';
import { useForm } from 'react-hook-form';
import { FaLocationDot } from "react-icons/fa6";
import { FaPhoneAlt } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { apiPost } from '../../../utils/Api';
import { ENDPOINTS } from '../../../utils/EndPoint';

const Contactus = () => {
    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
    } = useForm();

    const onSubmit = (data) => {
        console.log("Form Data Submitted: ", data);
        apiPost(
            ENDPOINTS.ContactFormPage,
            data,
            (res) => {
             console.log(res, "resresresres");
             
            },
            (err) => {
              console.log("Error updating user selected option", err);
            }
          );
        reset(); // Reset the form after submission
    };

    return (
        <div className='contact-us-sect bg-primary'>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-12'>
                        <h1 className='text-white h1-regular text-center pb-3'>Our Contact Us</h1>
                    </div>
                </div>
                <div className='row mt-5'>
                    <div className='col-md-6 ps-5 pe-5 pb-5'>
                        <div data-aos="fade-up">
                            <h2 className='text-white'>Get In Touch With Us</h2>
                            <form
                                className='contact-us-form pt-5'
                                onSubmit={handleSubmit(onSubmit)}
                            >
                                <div className='row'>
                                    <div className='col-md-6 mb-4'>
                                        <input
                                            type='text'
                                            className="form-control"
                                            placeholder='First Name'
                                            {...register('firstname', { required: "First Name is required" })}
                                        />
                                        {errors.firstname && (
                                            <small className="text-danger">{errors.firstname.message}</small>
                                        )}
                                    </div>
                                    <div className='col-md-6 mb-4'>
                                        <input
                                            type='text'
                                            className="form-control"
                                            placeholder='Last Name'
                                            {...register('lastname', { required: "Last Name is required" })}
                                        />
                                        {errors.lastname && (
                                            <small className="text-danger">{errors.lastname.message}</small>
                                        )}
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-md-6 mb-4'>
                                        <input
                                            type='email'
                                            className="form-control"
                                            placeholder='Enter your email'
                                            {...register('email', {
                                                required: "Email is required",
                                                pattern: {
                                                    value: /^\S+@\S+$/i,
                                                    message: "Invalid email format",
                                                },
                                            })}
                                        />
                                        {errors.email && (
                                            <small className="text-danger">{errors.email.message}</small>
                                        )}
                                    </div>
                                    <div className='col-md-6 mb-4'>
                                        <input
                                            type='text'
                                            className="form-control"
                                            placeholder='Subject'
                                            {...register('subject', { required: "Subject is required" })}
                                        />
                                        {errors.subject && (
                                            <small className="text-danger">{errors.subject.message}</small>
                                        )}
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-md-12'>
                                        <textarea
                                            placeholder='Message'
                                            className="form-control"
                                            rows="3"
                                            {...register('message', { required: "Message is required" })}
                                        />
                                        {errors.message && (
                                            <small className="text-danger">{errors.message.message}</small>
                                        )}
                                        <button type="submit" className="send-btn mt-4">Send Message</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div className='col-md-6 cont-col ps-3 pe-3'>
                        <div data-aos="fade-down">
                            <h2 className='text-white'>Contact Us</h2>
                            <div className='row align-items-center pt-3'>
                                <div className='col-xl-1 col-lg-12 col-md-2 pb-2'>
                                    <FaLocationDot fontSize={30} className='mb-2' color='white' />
                                </div>
                                <div className='col-xl-11 col-lg-12 col-md-10'>
                                    <h3 className='text-white'>Address</h3>
                                    <p className='text-white text-wrap mb-0'>London</p>
                                </div>
                            </div>
                            {/* <div className='row align-items-center pt-3'>
                                <div className='col-xl-1 col-lg-12 col-md-2 pb-2'>
                                    <FaPhoneAlt fontSize={30} className='mb-2' color='white' />
                                </div>
                                <div className='col-xl-11 col-lg-12 col-md-10'>
                                    <h3 className='text-white'>Phone</h3>
                                    <a href="tel:+1234-567-8901" className='text-secondary text-wrap'>+1 234-567-8901</a>
                                </div>
                            </div> */}
                            <div className='row align-items-center pt-3 pb-2'>
                                <div className='col-xl-1 col-lg-12 col-md-2'>
                                    <MdEmail fontSize={30} className='mb-2' color='white' />
                                </div>
                                <div className='col-xl-11 col-lg-12 col-md-10'>
                                    <h3 className='text-white'>Email</h3>
                                    <a href="mailto:skillz@sharkskillz.com" className='text-secondary text-wrap'>skillz@sharkskillz.com</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Contactus;
